import React, { useEffect, useState } from "react";
import { LightningIcon } from "@phosphor-icons/react";

/**
 * 30s founder-only window after a stream goes live. Shown to non-founder
 * viewers as a countdown overlay covering the video. When `seconds` ticks
 * to 0, fires `onUnlock()` so the parent can refetch the stream.
 */
export default function FounderHeadStartOverlay({ seconds: initialSeconds, onUnlock }) {
  const [seconds, setSeconds] = useState(initialSeconds || 0);

  useEffect(() => {
    if (!initialSeconds) return undefined;
    setSeconds(initialSeconds);
    const id = setInterval(() => {
      setSeconds((s) => {
        if (s <= 1) {
          clearInterval(id);
          if (onUnlock) onUnlock();
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(id);
  }, [initialSeconds, onUnlock]);

  return (
    <div
      className="absolute inset-0 z-30 flex flex-col items-center justify-center bg-black/85 backdrop-blur-md text-center px-6"
      data-testid="founder-head-start-overlay"
    >
      <div className="bidora-founder-avatar h-16 w-16 rounded-full grid place-items-center bg-gradient-to-br from-[#FFE08A] via-[#FF7AC6] to-[#FFE08A] mb-5">
        <LightningIcon size={28} weight="fill" className="text-[#5b1d4f]" />
      </div>
      <p className="text-[10px] tracking-[0.22em] uppercase font-bold text-amber-300">
        Founder head-start
      </p>
      <p className="text-2xl md:text-3xl font-display font-extrabold text-white mt-1">
        Live in {seconds}s
      </p>
      <p className="text-sm text-zinc-300 mt-2 max-w-sm">
        Founders are bidding right now. Public access opens in a few seconds.
      </p>
      <p className="text-xs text-zinc-500 mt-3">
        Earn your own Founder seat — first 100 verified buyers only.
      </p>
    </div>
  );
}
